export const objectToQueryParamsStr = (o: Record<string, string | number>) => {
  const queryParams = new URLSearchParams();

  Object.keys(o).forEach((key: string) => {
    if (o[key] !== undefined) {
      queryParams.append(key, String(o[key]));
    }
  });

  return queryParams.toString();
};
